//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as http from "@angular/common/http";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const TA_API_BASE_URL = new InjectionToken<string>('TA_API_BASE_URL');

@Injectable()
export class DashboardCustomGrantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(TA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param dashboardId (optional) 
     * @return OK
     */
    getAll(dashboardId: number | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/GetAll?";
        if (dashboardId === null)
            throw new Error("The parameter 'dashboardId' cannot be null.");
        else if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardId (optional) 
     * @return OK
     */
    getAllCustomGrantsPermissions(dashboardId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/GetAllCustomGrantsPermissions?";
        if (dashboardId === null)
            throw new Error("The parameter 'dashboardId' cannot be null.");
        else if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomGrantsPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomGrantsPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllCustomGrantsPermissions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardId (optional) 
     * @return OK
     */
    getAccessRestrictionSelectUsers(dashboardId: number | undefined): Observable<UserOrOrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/GetAccessRestrictionSelectUsers?";
        if (dashboardId === null)
            throw new Error("The parameter 'dashboardId' cannot be null.");
        else if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessRestrictionSelectUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessRestrictionSelectUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrOrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrOrganizationUnitDto[]>;
        }));
    }

    protected processGetAccessRestrictionSelectUsers(response: HttpResponseBase): Observable<UserOrOrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllWithProvisionalData(body: CustomGrantsWithAccessRestrictionInput | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/GetAllWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAllWithProvisionalData(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardId (optional) 
     * @param permissionName (optional) 
     * @return OK
     */
    getAllPossibleUsers(dashboardId: number | undefined, permissionName: string | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/GetAllPossibleUsers?";
        if (dashboardId === null)
            throw new Error("The parameter 'dashboardId' cannot be null.");
        else if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "permissionName=" + encodeURIComponent("" + permissionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPossibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsers(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllPossibleUsersWithProvisionalData(body: CustomGrantsForPermissionWithAccessRestrictionDataInput | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/GetAllPossibleUsersWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPossibleUsersWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsersWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsersWithProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAccessRestrictedUsers(): Observable<AnalyticsDashboardAccessRestrictedUsersDto> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/GetAccessRestrictedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessRestrictedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessRestrictedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnalyticsDashboardAccessRestrictedUsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnalyticsDashboardAccessRestrictedUsersDto>;
        }));
    }

    protected processGetAccessRestrictedUsers(response: HttpResponseBase): Observable<AnalyticsDashboardAccessRestrictedUsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalyticsDashboardAccessRestrictedUsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    checkCurrentUserIsInList(usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/DashboardCustomGrants/CheckCurrentUserIsInList?";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "usersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserIsInList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsInList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsInList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TaxAnalyticsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(TA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTaxAnalyticsDashboardOverviewDto> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalytics/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTaxAnalyticsDashboardOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTaxAnalyticsDashboardOverviewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTaxAnalyticsDashboardOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTaxAnalyticsDashboardOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<TaxAnalyticsDashboardOverviewDto> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalytics/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxAnalyticsDashboardOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxAnalyticsDashboardOverviewDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TaxAnalyticsDashboardOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxAnalyticsDashboardOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateTaxAnalyticsDashboardInput[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalytics/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateTaxAnalyticsDashboardInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalytics/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalytics/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPowerBiDashboards(body: PowerBiConfigurationsInput | undefined): Observable<PowerBiDashboardDto[]> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalytics/GetPowerBiDashboards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPowerBiDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPowerBiDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerBiDashboardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerBiDashboardDto[]>;
        }));
    }

    protected processGetPowerBiDashboards(response: HttpResponseBase): Observable<PowerBiDashboardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PowerBiDashboardDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    generateEmbedToken(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalytics/GenerateEmbedToken?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmbedToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmbedToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateEmbedToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TaxAnalyticsAdminSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(TA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<TaxAnalyticsAdminSettingsDto> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalyticsAdminSettings/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxAnalyticsAdminSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxAnalyticsAdminSettingsDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TaxAnalyticsAdminSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxAnalyticsAdminSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: TaxAnalyticsAdminSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/tax-analytics/TaxAnalyticsAdminSettings/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AnalyticsDashboardAccessRestrictedUsersDto implements IAnalyticsDashboardAccessRestrictedUsersDto {
    userOrOrganizations!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;

    constructor(data?: IAnalyticsDashboardAccessRestrictedUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userOrOrganizations"])) {
                this.userOrOrganizations = [] as any;
                for (let item of _data["userOrOrganizations"])
                    this.userOrOrganizations!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
        }
    }

    static fromJS(data: any): AnalyticsDashboardAccessRestrictedUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyticsDashboardAccessRestrictedUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userOrOrganizations)) {
            data["userOrOrganizations"] = [];
            for (let item of this.userOrOrganizations)
                data["userOrOrganizations"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        return data;
    }
}

export interface IAnalyticsDashboardAccessRestrictedUsersDto {
    userOrOrganizations: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
}

export class CreateTaxAnalyticsDashboardInput implements ICreateTaxAnalyticsDashboardInput {
    title!: string;
    type!: DashboardType;
    order!: number;
    dashboardAccessPermission!: CustomGrantsForPermissionInput | undefined;
    info!: string | undefined;

    constructor(data?: ICreateTaxAnalyticsDashboardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.dashboardAccessPermission = _data["dashboardAccessPermission"] ? CustomGrantsForPermissionInput.fromJS(_data["dashboardAccessPermission"]) : <any>undefined;
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): CreateTaxAnalyticsDashboardInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxAnalyticsDashboardInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["type"] = this.type;
        data["order"] = this.order;
        data["dashboardAccessPermission"] = this.dashboardAccessPermission ? this.dashboardAccessPermission.toJSON() : <any>undefined;
        data["info"] = this.info;
        return data;
    }
}

export interface ICreateTaxAnalyticsDashboardInput {
    title: string;
    type: DashboardType;
    order: number;
    dashboardAccessPermission: CustomGrantsForPermissionInput | undefined;
    info: string | undefined;
}

export class CustomGrantsForPermissionInput implements ICustomGrantsForPermissionInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;

    constructor(data?: ICustomGrantsForPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        return data;
    }
}

export interface ICustomGrantsForPermissionInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
}

export class CustomGrantsForPermissionWithAccessRestrictionDataInput implements ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICustomGrantsForPermissionWithAccessRestrictionDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionWithAccessRestrictionDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionWithAccessRestrictionDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
}

export class CustomGrantsWithAccessRestrictionInput implements ICustomGrantsWithAccessRestrictionInput {
    entityId!: number;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions!: CustomGrantsForPermissionInput[] | undefined;

    constructor(data?: ICustomGrantsWithAccessRestrictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            if (Array.isArray(_data["customGrantsForPermissions"])) {
                this.customGrantsForPermissions = [] as any;
                for (let item of _data["customGrantsForPermissions"])
                    this.customGrantsForPermissions!.push(CustomGrantsForPermissionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsWithAccessRestrictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsWithAccessRestrictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        if (Array.isArray(this.customGrantsForPermissions)) {
            data["customGrantsForPermissions"] = [];
            for (let item of this.customGrantsForPermissions)
                data["customGrantsForPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsWithAccessRestrictionInput {
    entityId: number;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions: CustomGrantsForPermissionInput[] | undefined;
}

export enum DashboardType {
    Website = 0,
    PowerBi = 1,
}

export class EntityPermissionDto implements IEntityPermissionDto {
    referenceId!: number;
    permissionName!: string | undefined;
    isActive!: boolean;
    possibleUsers!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    usersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    availableUsersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;

    constructor(data?: IEntityPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.permissionName = _data["permissionName"];
            this.isActive = _data["isActive"];
            this.possibleUsers = _data["possibleUsers"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["possibleUsers"]) : <any>undefined;
            this.usersOrOrganizationUnits = _data["usersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["usersOrOrganizationUnits"]) : <any>undefined;
            this.availableUsersOrOrganizationUnits = _data["availableUsersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["availableUsersOrOrganizationUnits"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["permissionName"] = this.permissionName;
        data["isActive"] = this.isActive;
        data["possibleUsers"] = this.possibleUsers ? this.possibleUsers.toJSON() : <any>undefined;
        data["usersOrOrganizationUnits"] = this.usersOrOrganizationUnits ? this.usersOrOrganizationUnits.toJSON() : <any>undefined;
        data["availableUsersOrOrganizationUnits"] = this.availableUsersOrOrganizationUnits ? this.availableUsersOrOrganizationUnits.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityPermissionDto {
    referenceId: number;
    permissionName: string | undefined;
    isActive: boolean;
    possibleUsers: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    usersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    availableUsersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
}

export class ListResultDtoOfUserOrOrganizationUnitDto implements IListResultDtoOfUserOrOrganizationUnitDto {
    items!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserOrOrganizationUnitDto {
    items: UserOrOrganizationUnitDto[] | undefined;
}

export class PagedResultDtoOfTaxAnalyticsDashboardOverviewDto implements IPagedResultDtoOfTaxAnalyticsDashboardOverviewDto {
    items!: TaxAnalyticsDashboardOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTaxAnalyticsDashboardOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaxAnalyticsDashboardOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTaxAnalyticsDashboardOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTaxAnalyticsDashboardOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTaxAnalyticsDashboardOverviewDto {
    items: TaxAnalyticsDashboardOverviewDto[] | undefined;
    totalCount: number;
}

export class PowerBiConfigurationsInput implements IPowerBiConfigurationsInput {
    tenantId!: string;
    clientId!: string;
    clientSecret!: string;

    constructor(data?: IPowerBiConfigurationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): PowerBiConfigurationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBiConfigurationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IPowerBiConfigurationsInput {
    tenantId: string;
    clientId: string;
    clientSecret: string;
}

export class PowerBiDashboardDto implements IPowerBiDashboardDto {
    id!: string;
    name!: string | undefined;
    embedUrl!: string | undefined;
    workspaceId!: string;
    type!: string | undefined;

    constructor(data?: IPowerBiDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.embedUrl = _data["embedUrl"];
            this.workspaceId = _data["workspaceId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PowerBiDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBiDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["embedUrl"] = this.embedUrl;
        data["workspaceId"] = this.workspaceId;
        data["type"] = this.type;
        return data;
    }
}

export interface IPowerBiDashboardDto {
    id: string;
    name: string | undefined;
    embedUrl: string | undefined;
    workspaceId: string;
    type: string | undefined;
}

export class TaxAnalyticsAdminSettingsDto implements ITaxAnalyticsAdminSettingsDto {
    isAccessRestrictionsActive!: boolean;

    constructor(data?: ITaxAnalyticsAdminSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestrictionsActive = _data["isAccessRestrictionsActive"];
        }
    }

    static fromJS(data: any): TaxAnalyticsAdminSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxAnalyticsAdminSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestrictionsActive"] = this.isAccessRestrictionsActive;
        return data;
    }
}

export interface ITaxAnalyticsAdminSettingsDto {
    isAccessRestrictionsActive: boolean;
}

export class TaxAnalyticsDashboardOverviewDto implements ITaxAnalyticsDashboardOverviewDto {
    id!: number;
    title!: string | undefined;
    type!: DashboardType | undefined;
    order!: number;
    info!: string | undefined;
    accessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;

    constructor(data?: ITaxAnalyticsDashboardOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.info = _data["info"];
            if (Array.isArray(_data["accessRestrictionPossibleUsers"])) {
                this.accessRestrictionPossibleUsers = [] as any;
                for (let item of _data["accessRestrictionPossibleUsers"])
                    this.accessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedAccessRestrictionPossibleUsers"])) {
                this.selectedAccessRestrictionPossibleUsers = [] as any;
                for (let item of _data["selectedAccessRestrictionPossibleUsers"])
                    this.selectedAccessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
        }
    }

    static fromJS(data: any): TaxAnalyticsDashboardOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxAnalyticsDashboardOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["type"] = this.type;
        data["order"] = this.order;
        data["info"] = this.info;
        if (Array.isArray(this.accessRestrictionPossibleUsers)) {
            data["accessRestrictionPossibleUsers"] = [];
            for (let item of this.accessRestrictionPossibleUsers)
                data["accessRestrictionPossibleUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedAccessRestrictionPossibleUsers)) {
            data["selectedAccessRestrictionPossibleUsers"] = [];
            for (let item of this.selectedAccessRestrictionPossibleUsers)
                data["selectedAccessRestrictionPossibleUsers"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        return data;
    }
}

export interface ITaxAnalyticsDashboardOverviewDto {
    id: number;
    title: string | undefined;
    type: DashboardType | undefined;
    order: number;
    info: string | undefined;
    accessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
}

export class UpdateTaxAnalyticsDashboardInput implements IUpdateTaxAnalyticsDashboardInput {
    title!: string;
    type!: DashboardType;
    order!: number;
    dashboardAccessPermission!: CustomGrantsForPermissionInput | undefined;
    id!: number;
    info!: string | undefined;

    constructor(data?: IUpdateTaxAnalyticsDashboardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.dashboardAccessPermission = _data["dashboardAccessPermission"] ? CustomGrantsForPermissionInput.fromJS(_data["dashboardAccessPermission"]) : <any>undefined;
            this.id = _data["id"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): UpdateTaxAnalyticsDashboardInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxAnalyticsDashboardInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["type"] = this.type;
        data["order"] = this.order;
        data["dashboardAccessPermission"] = this.dashboardAccessPermission ? this.dashboardAccessPermission.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["info"] = this.info;
        return data;
    }
}

export interface IUpdateTaxAnalyticsDashboardInput {
    title: string;
    type: DashboardType;
    order: number;
    dashboardAccessPermission: CustomGrantsForPermissionInput | undefined;
    id: number;
    info: string | undefined;
}

export class UserOrOrganizationUnitDto implements IUserOrOrganizationUnitDto {
    type!: string | undefined;
    userOrOrganizationId!: number;
    displayName!: string | undefined;

    constructor(data?: IUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserOrOrganizationUnitDto {
    type: string | undefined;
    userOrOrganizationId: number;
    displayName: string | undefined;
}

export class UserOrOrganizationUnitInput implements IUserOrOrganizationUnitInput {
    type!: string | undefined;
    userOrOrganizationId!: number;

    constructor(data?: IUserOrOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        return data;
    }
}

export interface IUserOrOrganizationUnitInput {
    type: string | undefined;
    userOrOrganizationId: number;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// copied from HttpClient.request, for some reason its not a type there ¯\_(ツ)_/¯ 
export interface RequestOptions {
    body?: any;
    headers?: http.HttpHeaders | {
        [header: string]: string | string[];
    };
    context?: http.HttpContext;
    observe?: 'body';
    params?: http.HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    reportProgress?: boolean;
    responseType: 'arraybuffer';
    withCredentials?: boolean;
    transferCache?: {
        includeHeaders?: string[];
    } | boolean;
}

export class ServiceProxyBase {
    async transformOptions(options: RequestOptions): Promise<RequestOptions> {
        return options
    }
}